import { Component, inject } from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { ToastItemComponent } from './toast-item/toast-item.component';

@Component({
	selector: 'vis-toast',
	imports: [ToastItemComponent],
	templateUrl: './toast.component.html',
	styleUrls: ['./toast.component.scss'],
})
export class ToastComponent {
	public toast = inject(ToastService);
}
